import styled from 'styled-components';

import { Breakpoints } from '@lichtblick/theme';

export const PageContainer = styled.main`
  margin: 0 auto;
  max-width: ${Breakpoints.Max}px;
`;
